import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ReleaseNotes } from './release-notes.actions';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import * as xml2js from 'xml2js';
import { environment } from '../../../environments/environment';
import { of } from 'rxjs';
import { RssResponse } from './release-notes.reducer';
import { ApplicationReady } from '../actions';

@Injectable()
export class ReleaseNotesEffects {
  getRssFeedData() {
    const requestOptions: Object = {
      observe: 'body',
      responseType: 'text',
    };
    return this.http
      .get<any>(environment.releaseNotes.feedUrl, requestOptions)
      .pipe(switchMap((data) => xml2js.parseStringPromise(data)));
  }

  
  requestOnAppStart = createEffect(() => this.actions$.pipe(
    ofType(ApplicationReady),
    map(() => ReleaseNotes.RequestReleaseNotesAction())
  ));

  
  retrieveReleaseNotes = createEffect(() => this.actions$.pipe(
    ofType(ReleaseNotes.REQUEST_RETRIEVE_ALL),
    switchMap(() =>
      this.getRssFeedData().pipe(
        map((parsedXml: RssResponse) =>
          ReleaseNotes.ResponseSuccessRetrieveReleaseNotesAction(parsedXml)
        ),
        catchError((error) =>
          of(ReleaseNotes.ResponseFailRetrieveReleaseNotesAction({ error: error }))
        )
      )
    )
  ));

  constructor(private store: Store<any>, private actions$: Actions, private http: HttpClient) {}
}
